import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    employerName: '',
    employerEmail: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    province: '',
    country: '',
    zipOrPostalCode: '',
    dateOfTerminationRedundancy: '',
    howManyYearsDidYouWorkThere: '',
    describe: '',
    areYouGainfullyEmployedNow: 'false',
    haveYouBeenEmployedFullTime: 'false',
    haveYouFiledForUnemploymentBenefits: 'false',
    wasYourEmploymentStatusSeasonal: 'false',
    wasYourEmploymentStatusRetiredOrResigned: 'false',
    haveYouBeenContinuouslyUnemployed: 'false',
    newEmployerName: '',
    newEmployerAddress: '',
    dateYouBeganNewEmployment: '',
  },
  errors: [],
});

function medicalHardshipStepReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    default:
      return state;
  }
}

export default medicalHardshipStepReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.DuesProtect.JobLossHardshipStep/reducer.js